// extracted by mini-css-extract-plugin
export default {"circle":"PaymentToBp_circle__tY61W"};